import Modal from "@/components/common/modal";
import { DialogFooter } from "@/components/ui/dialog";
import {
  type OptionalDenyCorrectionFormData,
  optionalSchema,
} from "@/schemas/procedures/deny-correction";
import { Button, TextAreaField } from "@elaniintc/goes-design-system";
import { zodResolver } from "@hookform/resolvers/zod";
import { useForm } from "react-hook-form";

interface Props {
  isOpen: boolean;
  isLoading?: boolean;
  onClose: () => void;
  onAccept: (val: { description?: string }) => void;
}

const DenyGeneralReasonModal = ({
  isOpen,
  isLoading,
  onClose,
  onAccept,
}: Props) => {
  const {
    register,
    watch,
    handleSubmit,
    formState: { errors, isValid },
  } = useForm<OptionalDenyCorrectionFormData>({
    resolver: zodResolver(optionalSchema),
    mode: "onChange",
    reValidateMode: "onChange",
  });
  const [reason] = watch(["reason"]);

  const onSubmit = async (data: OptionalDenyCorrectionFormData) => {
    onAccept({
      description: data.reason || "No se agregaron comentarios adicionales.",
    });
  };

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      title="Comentario general"
      description="Describe brevemente y de manera general las correcciones que el tramitadór necesita realizar."
      modalContentClassName="max-w-[520px] w-full gap-7"
    >
      <form
        className="flex flex-col gap-6"
        onSubmit={(e) => {
          e.preventDefault();
          e.stopPropagation();
          handleSubmit(onSubmit)(e);
        }}
        id="edit-role-form"
      >
        <TextAreaField
          label="Comentario de correccciones"
          helperText="Opcional"
          placeholder="Escribe tu comentario..."
          className="relative h-[88px] max-h-[88px]"
          {...register("reason")}
          limit={5000}
          count={reason?.length || 0}
          error={errors.reason?.message}
        />
        <DialogFooter className="pt-1">
          <div className="w-full grid grid-cols-1 tablet:grid-cols-2 gap-3">
            <Button
              size="lg"
              type="button"
              className="w-full rounded-lg"
              variant="tertiary"
              onClick={onClose}
              disabled={isLoading}
            >
              Cancelar
            </Button>
            <Button
              size="lg"
              variant="danger-secondary"
              className="w-full rounded-lg"
              type="submit"
              disabled={!isValid || isLoading}
              isLoading={isLoading}
            >
              Enviar
            </Button>
          </div>
        </DialogFooter>
      </form>
    </Modal>
  );
};

export { DenyGeneralReasonModal };
